/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PublistConfigProjectOrganisation
 */
export interface PublistConfigProjectOrganisation  {
    /**
     * 
     * @type {Array<number>}
     * @memberof PublistConfigProjectOrganisation
     */
    organisationIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PublistConfigProjectOrganisation
     */
    withOrganisationHierarchy?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PublistConfigProjectOrganisation
     */
    projectIds?: Array<number>;
    /**
     * 
     * @type {PublistConfigProjectOrganisationDeterminationTypeEnum}
     * @memberof PublistConfigProjectOrganisation
     */
    determinationType?: PublistConfigProjectOrganisationDeterminationTypeEnum;
    /**
     * 
     * @type {PublistConfigProjectOrganisationFilterMembersEnum}
     * @memberof PublistConfigProjectOrganisation
     */
    filterMembers?: PublistConfigProjectOrganisationFilterMembersEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublistConfigProjectOrganisation
     */
    considerEmploymentPeriod?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublistConfigProjectOrganisation
     */
    restrictToRoles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublistConfigProjectOrganisation
     */
    excludeByRoles?: Array<string>;
}


/**
 * @export
 */
export const PublistConfigProjectOrganisationDeterminationTypeEnum = {
    Members: 'MEMBERS',
    Self: 'SELF',
    Direct: 'DIRECT'
} as const;
export type PublistConfigProjectOrganisationDeterminationTypeEnum = typeof PublistConfigProjectOrganisationDeterminationTypeEnum[keyof typeof PublistConfigProjectOrganisationDeterminationTypeEnum];

/**
 * @export
 */
export const PublistConfigProjectOrganisationFilterMembersEnum = {
    Current: 'CURRENT',
    Former: 'FORMER',
    All: 'ALL'
} as const;
export type PublistConfigProjectOrganisationFilterMembersEnum = typeof PublistConfigProjectOrganisationFilterMembersEnum[keyof typeof PublistConfigProjectOrganisationFilterMembersEnum];


/**
 * Check if a given object implements the PublistConfigProjectOrganisation interface.
 */
export function instanceOfPublistConfigProjectOrganisation(value: object): value is PublistConfigProjectOrganisation {
    return true;
}

export function PublistConfigProjectOrganisationFromJSON(json: any): PublistConfigProjectOrganisation {
    return PublistConfigProjectOrganisationFromJSONTyped(json, false);
}

export function PublistConfigProjectOrganisationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublistConfigProjectOrganisation {
    if (json == null) {
        return json;
    }
    return {
        
              'organisationIds': json['organisationIds'] == null ? undefined : json['organisationIds'],
                  'withOrganisationHierarchy': json['withOrganisationHierarchy'] == null ? undefined : json['withOrganisationHierarchy'],
              'projectIds': json['projectIds'] == null ? undefined : json['projectIds'],
                  'determinationType': json['determinationType'] == null ? undefined : json['determinationType'],
                  'filterMembers': json['filterMembers'] == null ? undefined : json['filterMembers'],
                  'considerEmploymentPeriod': json['considerEmploymentPeriod'] == null ? undefined : json['considerEmploymentPeriod'],
              'restrictToRoles': json['restrictToRoles'] == null ? undefined : json['restrictToRoles'],
              'excludeByRoles': json['excludeByRoles'] == null ? undefined : json['excludeByRoles'],
    };
}

export function PublistConfigProjectOrganisationToJSON(json: any): PublistConfigProjectOrganisation {
    return PublistConfigProjectOrganisationToJSONTyped(json, false);
}

export function PublistConfigProjectOrganisationToJSONTyped(value?: PublistConfigProjectOrganisation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organisationIds': value['organisationIds'] == null? value['organisationIds']: value['organisationIds'],
        'withOrganisationHierarchy': value['withOrganisationHierarchy'],
        'projectIds': value['projectIds'] == null? value['projectIds']: value['projectIds'],
        'determinationType': value['determinationType'],
        'filterMembers': value['filterMembers'],
        'considerEmploymentPeriod': value['considerEmploymentPeriod'],
        'restrictToRoles': value['restrictToRoles'] == null? value['restrictToRoles']: value['restrictToRoles'],
        'excludeByRoles': value['excludeByRoles'] == null? value['excludeByRoles']: value['excludeByRoles'],
    };
}


